module.exports = __webpack_public_path__ + "img/126716-28-7.16adb1ed.png";